import { Fragment } from 'react';
import { LogoLaerdalGlobalHealth, LghLogomarkColor } from '@tbd/life-jsx/Logos';
export function LGHLogo() {
  return (
    <Fragment>
      <LogoLaerdalGlobalHealth
        sx={{
          display: { xs: 'none', md: 'block' },
          width: '88px',
          height: '48px',
        }}
      />
      <LghLogomarkColor
        sx={{
          display: { xs: 'block', md: 'none' },
          width: '32px',
          height: '32px',
        }}
      />
    </Fragment>
  );
}
//90.4px
